<template>
  <div>
    <el-button class="goBack" @click="goBack">返回</el-button>
    <div class="setSome">
      <div class="title_1">
        <div class="iconShow"></div>
        <div class="titleText">标段详情</div>
      </div>
      <div class="sectionSetItem">
        <div class="itemText"><span style="color:#E96B5A">* </span>作业块名称</div>
        <div class="inputCon">
          <el-input
            placeholder="请输入作业块名称"
            v-model="sectionName"
          ></el-input>
        </div>
      </div>
      <!-- <div class="sectionSetItem">
        <div class="itemText"><span style="color:#E96B5A">* </span>作业方向角</div>
        <div class="inputCon">
          <el-input
            placeholder="请输入0-360之间的数值"
            v-model="addObj.sectionAngle"
            @input="inputChange"
          ></el-input>
        </div>
      </div> -->
      <div class="sectionSetItem">
        <div class="itemText"> 所属层</div>
        <div class="inputCon">
          <el-input
            placeholder="请输入层名称"
            v-model="roadName"
            disabled
          ></el-input>
        </div>
      </div>
      <div class="sectionSetItem">
        <div class="itemText">当前划定面积</div>
        <div class="inputCon">
          <el-input placeholder="请输入面积" v-model="area" disabled></el-input>
        </div>
      </div>
      <div class="title_1">
        <div class="iconShow"></div>
        <div class="titleText">请选择输入方式</div>
        <div class="inputCon1">
          <el-select v-model="inputway" placeholder="请选择输入方式">
            <el-option
              v-for="item in inputWayList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="pointerList">
        <div class="listContain">
          <div style="paddingBottom: 8px" v-if="inputway == '手动输入'">
            请输入顶点坐标：
            <span 
              @click="selectAllPointer"
              style="display:inline-block;height:30px;lineHeight:24px;border:1px solid #E96B5A;padding:3px 6px;borderRadius:5px;marginLeft:103px;cursor:pointer;fontSize:14px;background:#fde3e1;color:#E96B5A">
              选择全部
            </span>
          </div>
          <div style="paddingBottom: 8px;paddingLeft:18px" v-if="inputway == '压路机采集'" class="roller">
            请选择压路机：
            <el-select v-model="addObj.equipCode" @change="changeEquip" placeholder="请选择采点压路机">
                <el-option
                  v-for="item in equipList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
          </div>
           
          <div class="tablelistBody">
            <el-table
              :data="dataList"
              style="width: 100%"
              size="medium"
              v-loading="listLoading"
            >
              <el-table-column prop="name" label="顶点" width="60px">
                <template slot-scope="scope">
                  <span class="pointerName">{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="x" label="X轴" width="">
                <template slot-scope="scope">
                  <el-input
                    style="color: #282828"
                    placeholder=""
                    v-model="scope.row.x"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="y" label="Y轴" width="">
                <template slot-scope="scope">
                  <el-input
                    style="color: #282828"
                    placeholder=""
                    v-model="scope.row.y"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="tableBut" v-if="inputway == '手动输入'">
            <el-button
              type="danger"
              danger
              style="width: 105px"
              @click="addPointer(dataList.length)"
              >增加一个顶点</el-button
            >
            <el-button
              type="warning"
              danger
              style="width: 105px"
              @click="delPointer(dataList.length)"
              >删除一个顶点</el-button
            >
            <el-button type="info" plain @click="resetPoint"
              >全部重置</el-button
            >
            <el-button
              type="danger"
              danger
              @click="assignment(1)"
              style="width: 305px; marginTop: 10px; marginLeft: 0px"
              >划定作业块</el-button
            >
          </div>
          <div class="tableBut" v-if="inputway == '压路机采集'">
            <el-button
              type="danger"
              danger
              style="width: 105px"
              @click="pickPointer(dataList.length)"
              >采集当前点</el-button
            >
            <el-button
              type="warning"
              danger
              style="width: 105px"
              @click="delPointer(dataList.length)"
              >删除上一点</el-button
            >
            <el-button type="info" plain @click="resetPoint"
              >全部重置</el-button
            >
            <el-button
              type="danger"
              danger
              @click="assignment(1)"
              style="width: 305px; marginTop: 10px; marginLeft: 0px"
              >划定作业块</el-button
            >
          </div>
        </div>
      </div>
      <div
        class="sectionBtn saveDiv"
        @click="saveFun"
      >
        保存
      </div>
    </div>
    <div class="canvasCon2">
      <div class="canvas-container1">
        <canvas id="myCanvasun1" width="1490" height="810"></canvas>
        <canvas id="midCanvas1" width="1490" height="810"></canvas>
        <canvas id="dhCanvasun2" width="1490" height="810"></canvas>
      </div>
    </div>
    <!-- <img :src="zhizhen" alt="" id="img"> -->
  </div>
</template>

<script>
import { fabric } from "fabric";
import {
  addRoadSection,
  editRoadSection,
  getRoadInfo,
  getRoadInfoDetails,
  // getRoadSection,
  // getEquipListOnline
} from "../../utils/api";

import { sendWSPush } from '../../utils/websocket'
import mixinList from "../../utils/mixinList";
import websockMix from "../../utils/websockMix"
import { calculateArea } from '../../utils/commons'
export default {
  name: "app",
  mixins: [mixinList,websockMix],
  data() {
    return {
      addObj: {},
      getChangeObj: "",
      scaleCode: "",
      leftDistance: "",
      topDistance: "",
      canvas: "",
      carcanvas:"",
      pointNum: 1,
      barNum: 1,
      dataList: [],
      bardataList: [],
      inputway:'手动输入',
      equipList:[],
      carList: [],
      // barListCont:[
      //     {
      //       cord:["S1(15.0,15.0)","S2(15.0,15.0)","S3(15.0,15.0)","S4(15.0,15.0)"]
      //     },
      //     {
      //       cord:["S1(15.0,25.0)","S2(15.0,15.0)","S3(25.0,15.0)","S4(25.0,15.0)"]
      //     },
      // ],
      setGray: 1,
      mileageValue: "",
      inputWayList: [
        // {
        //   label: "压路机采集",
        //   value: "压路机采集",
        // },
        {
          label: "手动输入",
          value: "手动输入",
        },
      ],
      barList: [
        {
          label: "圆形",
          value: "圆形",
        },
        {
          label: "矩形",
          value: "矩形",
        },
      ],
      arrowList: [
        // {
        //   name: "首页",
        //   path: "/",
        // },
        // {
        //   name: "工程中心",
        //   path: "/transfer",
        // },
        {
          name: "道路管理",
          path: "/transfer/roadList",
        },
        {
          name: "道路详情",
          path: "/transfer/unroadInfo",
        },
        {
          name: "作业块划分",
          path: "/transfer/unroadSection",
        },
      ],
      roadId: "",
      roadType: "",
      roadName:'',
      area:'',
      roadPointers: [],
      pileNumPointers: [],
      canvasBG: "#ffffff",
      inType: "",
      sectionId: "",
      resPositionInfo:"",
      carWidthMap: '',
      fabricClickId: '', //canvas 点击到的车辆id
      fabricClickName: '',
      parameterArr: ['icv','speed','temperature','oilmass','frequencyVal','swingVal'],
      parameterPavArr: ['speed','temperature','oilmass'],
      parameterRollSArr: ['icv','speed','temperature','oilmass','frequencyVal','swingVal'],
      parameterRollLArr: ['speed','temperature','oilmass'],
      setMask: 0,
      directionPoint:[{x:60,y:100,name:"起点"},{x:120,y:100,name:"终点"}],
      // zhizhen:require('../../images/all/jiantou.png'),
      cengid:0,
      sectionName:'',
      sourceType:''
    };
  },
  computed: {},
  created() {},
  mounted() {
    // createSocket('ws://172.16.16.105:9998/ws')
      this.$store.commit("setArrowList", this.arrowList);
      this.roadId = this.$route.query.id;
      this.cengid = this.$route.query.cengid || 0;
      this.roadType = this.$route.query.roadType;
      this.addObj.roadType = this.$route.query.roadType;
      this.inType = this.$route.query.type;
      let params = {
        id: this.roadId,
      };
    getRoadInfo({roadId: this.roadId,pageSize: 100}).then((res) => {
      this.sourceType = res.data.content.info.sourceType
    })  
    getRoadInfoDetails(params).then((res) => {
      this.carList=[];
      let dataMap={}
      res.data.content.info.list.map(item=>{
        if(item.id==this.cengid){
          dataMap=item
          this.roadName=item.roadName
          console.log(item,'item')
        }
      })
      let changeObj = this.changeUnRoadPointer(1490, 810, dataMap);
      this.getChangeObj = changeObj[0];
      this.$store.commit("setScaleCode", this.scaleCode);
      this.canvas = new fabric.Canvas("midCanvas1", {
        // perPixelTargetFind: false,
      });
      this.carcanvas = new fabric.Canvas("dhCanvasun2", {
        perPixelTargetFind: true,
      });
      this.canvas.selectable = false;
      this.initCanvas(this.carcanvas, this.canvas, this.getChangeObj);
      this.scaleCode = localStorage.getItem('scaleCode')
      this.setGrid();
      if(this.inType == 'edit'){
          this.sectionId = this.$route.query.sectionid
          dataMap.roadSections.map(i=>{
            if(i.id==this.sectionId){
              this.sectionName=i.sectionName
              this.inputway = '手动输入';
              this.area=i.area
              this.dataList = i.vertexList
              this.assignment(1);
              this.setGrid();
            }
          })
        }
      });
      // getEquipListOnline().then(res=>{
      //   console.log(res.data.content.dataList,"在线设备。。。。。。。")
      //   let setMap = new Map()
      //   res.data.content.dataList.map((item)=>{
      //     this.equipList.push({label:item[1],value:item[0]})
      //     setMap.set(item[0],item[2])
      //   })
      //   this.carWidthMap = setMap
      // })
  },
  methods: {
    // inputChange(e){
    //   var reg = /^[0-9]+.?[0-9]*$/;
    //   if (reg.test(e*1)) {
    //     this.setGrid();
    //   }else{
    //     this.addObj.sectionAngle=''
    //     this.setGrid();
    //   }
    // },
    selectAllPointer(){
      console.log(this.getChangeObj,'this.getChangeObj')
      this.dataList=[]
      let setArr=this.getChangeObj[1]
      for (let i = 0; i < setArr.length; i++) {
        this.dataList.push({ x: setArr[i].x, y: setArr[i].y, name: "W" + i });
      }
      this.pointNum = setArr.length;
    },
    changeEquip(){
      this.carList=[];
      this.carcanvas.clear();
      let that=this;
      let setStr = '/GetEquipStatusData?equipCode='+this.addObj.equipCode //这里的id需要重定接口
      // let setStr ='/GetWorkStatus';
        sendWSPush(setStr,function(res){
          if(!res.content){
          console.log(res,"ressssssssssssssssss11")
            that.resPositionInfo=res;
            that.drawByWork(that.carcanvas,that.canvas,res)
          }
        })
    },
    goBack: function () {
      this.$router.go(-1);
    },
    numTofont(num){//数字转换成汉字
        let arr=["一","二","三","四","五","六","七","八","九","十"];
        if(num<=9){
            return arr[num]
        }else if((num+1)%10==0){
            return arr[(num+1)/10-1]+"十"
        }else if(10<=num<19){
            return "十"+arr[num-10]
        }else if(20<=num<=98){
            return arr[parseInt(num/10)]+"十"+arr[num%10]
        }
    },
    removeBarCont(index){ //删除障碍区域
        this.barListCont.splice(index,1);
    },
    drawPickPoint(canvas, getArr){//绘制压路机采点的点位
      for (let i = 0; i < getArr.length; i++) {
        canvas.add(
          new fabric.Text(getArr[i].name, {
            fontSize: 12,
            top: getArr[i].y + 5,
            left: getArr[i].x + 5,
            selectable: false,
            hasBorders: false,
            hasControls: false,
            fill: "black",
          })
        );
        canvas.add(
          new fabric.Circle({
            radius: 3,
            top: getArr[i].y - 3, //调整中心点的X轴坐标
            left: getArr[i].x - 3,
            selectable: false,
            hasBorders: false,
            hasControls: false,
            fill: "#000",
          })
        );
      }
    },
    drawSec(canvas, getArr) {
      let workPath = "";
      for (let i = 0; i < getArr.length; i++) {
        if (i == 0) {
          workPath = "M" + " " + getArr[0].x + " " + getArr[0].y;
        } else {
          workPath += " " + "L" + " " + getArr[i].x + " " + getArr[i].y;
        }
        canvas.add(
          new fabric.Text(getArr[i].name, {
            fontSize: 12,
            top: getArr[i].y + 5,
            left: getArr[i].x + 5,
            selectable: false,
            hasBorders: false,
            hasControls: false,
            fill: "black",
          })
        );
        canvas.add(
          new fabric.Circle({
            radius: 3,
            top: getArr[i].y - 3, //调整中心点的X轴坐标
            left: getArr[i].x - 3,
            selectable: false,
            hasBorders: false,
            hasControls: false,
            fill: "#000",
          })
        );
      }
      workPath = workPath + "z";
      canvas.add(
        new fabric.Path(workPath, {
          strokeWidth: 1,
          stroke: "blue",
          fill: "RGBA(213,255,255,0.5)",
          // strokeDashArray: [1,1],
          selectable: false,
          hasBorders: false,
          hasControls: false,
        })
      );
    },
    assignment(num) {//划定作业块并进行绘制
      let getArr = JSON.parse(JSON.stringify(this.dataList));
      getArr.map((item) => {
        item.x = item.x / this.scaleCode + this.leftDistance;
        item.y = -item.y / this.scaleCode + this.topDistance;
      });
      this.canvas.clear();
      this.carList=[];
      // this.initCanvas(this.carcanvas,this.canvas, this.getChangeObj);
      this.setRoad(this.canvas,this.getChangeObj);
      this.area=calculateArea(this.dataList)
      if(num==1){
        this.drawSec(this.canvas, getArr);//1代表手动输入或压路机采点绘制区域
      }else if(num==2){
        this.drawPickPoint(this.canvas, getArr);//2代表压路机采点的点位绘制
      }
      this.changeSetGray();
    },
    // addBarPoint(num) {
    //   this.bardataList.push({ x: 0.0, y: 0.0, name: "S" + num });
    //   this.barNum = num + 1;
    // },
    // resetBarPoint() {
    //   this.bardataList.map((item) => {
    //     item.x = 0.0;
    //     item.y = 0.0;
    //   });
    // },
    resetPoint() {
      if(this.inputway=="手动输入"){
        this.dataList.map((item) => {
          item.x = 0.0;
          item.y = 0.0;
        });
      }else{
          this.dataList=[];
      }
    },
    delPointer(num) {
      this.dataList.pop();
      this.pointNum = num - 1;
      this.assignment(2);
    },
    addPointer(num) {
      this.dataList.push({ x: 0.0, y: 0.0, name: (this.dataList[0]?this.dataList[0].name.charAt(0):"W") + num });
      this.pointNum = num + 1;
    },
    pickPointer(num) {//压路机采点
      this.dataList.push({ x: this.resPositionInfo.coordinateX, y: this.resPositionInfo.coordinateY, name: (this.dataList[0]?this.dataList[0].name.charAt(0):"W") + num });
      this.pointNum = num + 1;
      this.assignment(2);
    },
    initCanvas: function (canvas, midCanvas, setArr,type) {
      var that = this
      canvas.selections = false
      // this.setGrid(canvas,"#ffffff")
      if(type == 1){
          this.setRoad(canvas,setArr)
      }else{
          this.setRoad(midCanvas,setArr)
      }
      //鼠标按下事件
      canvas.on("mouse:down", function (e) {
        if (e.target != null) {
        if ("id" in e.target) {
            that.fabricClickId = e.target.id;
            that.fabricClickName = e.target.carName;
            let topD = e.pointer.y - 80;
            let leftD = e.pointer.x;
            if (midCanvas != "") {
            that.$refs.setCarInfo.style.top = topD + "px";
            that.$refs.setCarInfo.style.left = leftD + "px";
            that.$refs.setCarInfo.style.display = "block";
            }
        }
        } else {
        if (midCanvas != "") {
            // that.$refs.setCarInfo.style.display = "none";  
        }
        }
        this.panning = true;
    });
    //鼠标抬起事件
    canvas.on("mouse:up", function () {
        this.panning = false;
    });
    // 移动画布事件
    canvas.on("mouse:move", function (e) {
        // //console.log(canvas.getObjects())
        if (this.panning && e && e.e) {
        var delta = new fabric.Point(e.e.movementX, e.e.movementY);
        canvas.relativePan(delta);
        if (midCanvas != "") {
            midCanvas.relativePan(delta);
        }
        }
      });
      var leftTo = canvas._offset.left;
      var topTo = canvas._offset.top;
      // 鼠标滚动画布放大缩小
      canvas.on("mouse:wheel", function () {
          //console.log(event)
          var zoom = (event.deltaY > 0 ? -0.1 : 0.1) + canvas.getZoom();
          zoom = Math.max(0.3, zoom); //最小为原来的1/10
          zoom = Math.min(10, zoom); //最大是原来的3倍
          that.$store.commit("setZoom", zoom);
          var zoomPoint = new fabric.Point(
          event.pageX - leftTo,
          event.pageY - topTo
          );
          canvas.zoomToPoint(zoomPoint, zoom);
          if (midCanvas != "") {
          midCanvas.zoomToPoint(zoomPoint, zoom);
          }
      });
    },
    setGrid() {
      let myCanvas = document.getElementById("myCanvasun1");
      let ctx = myCanvas.getContext("2d");
      let gridSize = 50;
      let canvasWidth = ctx.canvas.width;
      let canvasHeight = ctx.canvas.height;
      let xLineTotal = Math.floor(canvasHeight / gridSize);
      let yLineTotal = Math.floor(canvasWidth / gridSize);
      ctx.fillStyle = "#E1E0E0";
      ctx.fillRect(0, 0, canvasWidth, canvasHeight);
      ctx.stroke();
      for (let i = 0; i <= xLineTotal; i++) {
        ctx.beginPath();
        ctx.moveTo(0, i * gridSize - 0.5);
        ctx.lineTo(canvasWidth, i * gridSize - 0.5);
        ctx.strokeStyle = "#D8D6D4";
        ctx.stroke();
      }
      for (let i = 0; i <= yLineTotal; i++) {
        ctx.beginPath();
        ctx.moveTo(i * gridSize - 0.5, 0);
        ctx.lineTo(i * gridSize - 0.5, canvasHeight);
        ctx.strokeStyle = "#D8D6D4";
        ctx.stroke();
      }
      // var img = document.getElementById('img')
      // // if(this.addObj.sectionAngle){
      //   ctx.font="18px bold 黑体";
      //   ctx.fillStyle="#000000";
      //   ctx.fillText("作业方向",30,30)
      //   //旋转图片 
      //   ctx.translate(100, 100)
      //   ctx.rotate(-(this.addObj.sectionAngle/180*Math.PI)) // 2
      //   ctx.drawImage(img, -64, -64)
        
      //   // 恢复设置（恢复的步骤要跟你修改的步骤向反）
      //   ctx.rotate((this.addObj.sectionAngle/180*Math.PI)) // 1
      //   ctx.translate(-100, -100) // 2
        
      // // }
    },
    setRoad(canvas, setArr) {
      let leftArr = setArr[0];
      let barArr = setArr[2];
      let areaArr = leftArr;
      let areaPath = "M" + " " + areaArr[0][0] + " " + areaArr[0][1];
      for (let i = 1; i < areaArr.length; i++) {
        areaPath += " " + "L" + " " + areaArr[i][0] + " " + areaArr[i][1];
      }
      areaPath = areaPath + "z";
      canvas.add(
        new fabric.Path(areaPath, {
          strokeWidth: 2,
          stroke: "black",
          fill: "RGBA(132,132,198,0)",
          // strokeDashArray: [1,1],
          selectable: false,
          hasBorders: false,
          hasControls: false,
        })
      );
      for (let i = 0; i < barArr.length; i++) {
        let barPath = "";
        for (let j = 0; j < barArr[i].length; j++) {
          if (j == 0) {
            barPath = "M" + " " + barArr[i][0].x + " " + barArr[i][0].y;
          } else {
            barPath += " " + "L" + " " + barArr[i][j].x + " " + barArr[i][j].y;
          }
          canvas.add(
            new fabric.Text("S" + j, {
              fontSize: 12,
              top: barArr[i][j].y + 5,
              left: barArr[i][j].x + 5,
              selectable: false,
              hasBorders: false,
              hasControls: false,
              fill: "black",
            })
          );
          canvas.add(
            new fabric.Circle({
              radius: 3,
              top: barArr[i][j].y - 3, //调整中心点的X轴坐标
              left: barArr[i][j].x - 3,
              selectable: false,
              hasBorders: false,
              hasControls: false,
              fill: "#000",
            })
          );
        }
        barPath = barPath + "z";
        canvas.add(
          new fabric.Path(barPath, {
            strokeWidth: 1,
            stroke: "black",
            fill: "RGBA(132,132,198,0.2)",
            // strokeDashArray: [1,1],
            selectable: false,
            hasBorders: false,
            hasControls: false,
          })
        );
      }
      for (let i = 0; i < setArr[1].length; i++) {
        canvas.add(
          new fabric.Text(
            setArr[1][i].name +
              "(" +
              setArr[1][i].x +
              "," +
              setArr[1][i].y +
              ")",
            {
              fontSize: 14,
              top: setArr[0][i][1] * 1.05 - 20,
              left: setArr[0][i][0] * 1.05 - 58,
              selectable: false,
              hasBorders: false,
              hasControls: false,
              fill: "black",
            }
          )
        );
      }
      // this.setGroupFun(canvas)
    },
    changeUnRoadPointer(width, height, setObj) {
      let pileNumList = [];
      for (let i = 0; i < setObj.vertexList.length; i++) {
        pileNumList.push(setObj.vertexList[i]);
      }
      let visualWidth = 50;
      let visualHeight = 50;
      let widthArea = width - visualWidth;
      let heigthArea = height - visualHeight;
      let vertexList = this.arrToArr(setObj.vertexList);
      let blockList = this.arrToArr1(setObj.blockList);
      let xcordArr = this.arrToDArr(vertexList, 0);
      let ycordArr = this.arrToDArr(vertexList, 1);
      let xMaxCode = this.getMaxAMin(xcordArr, "max");
      let xMinCode = this.getMaxAMin(xcordArr, "min");
      let yMaxCode = this.getMaxAMin(ycordArr, "max");
      let yMinCode = this.getMaxAMin(ycordArr, "min");
      // 获取x与y轴道路数据最大差距
      let xGap =
        xMaxCode - xMinCode > 0 ? xMaxCode - xMinCode : -(xMaxCode - xMinCode);
      let yGap =
        yMaxCode - yMinCode > 0 ? yMaxCode - yMinCode : -(yMaxCode - yMinCode);
      // 获取x与y轴对于canvas高宽的比例
      let xScale = xGap / (widthArea - 50);
      let yScale = yGap / (heigthArea - 50);
      //设置页面canvas比列大小
      this.scaleCode = xScale > yScale ? xScale : yScale;
      localStorage.setItem('scaleCode',this.scaleCode)
      // 获取缩放后的道路和障碍区数据
      let midScaledLine = this.roadScale(vertexList, this.scaleCode);
      let barScaledLine = this.roadScale1(blockList, this.scaleCode);
      // 获取缩放后的道路数据中x与y轴最小值
      let scaledXMinCode = this.getMaxAMin(
        this.arrToDArr(midScaledLine, 0),
        "min"
      ).toFixed(2);
      let scaledXMaxCode = this.getMaxAMin(
        this.arrToDArr(midScaledLine, 0),
        "max"
      ).toFixed(2);
      let scaledYMinCode = this.getMaxAMin(
        this.arrToDArr(midScaledLine, 1),
        "min"
      ).toFixed(2);
      let scaledYMaxCode = this.getMaxAMin(
        this.arrToDArr(midScaledLine, 1),
        "max"
      ).toFixed(2);
      let addX = width / 2 - (scaledXMaxCode - scaledXMinCode) / 2;
      let addY = height / 2 - (scaledYMaxCode - scaledYMinCode) / 2;
      // 缩放后的道路数据中x与y轴最小值移动到左边与上边的差距值
      this.leftDistance = visualHeight / 2 - scaledXMinCode + addX - 23;
      this.topDistance = visualHeight / 2 - scaledYMinCode + addY - 15;
      localStorage.setItem('leftDistance',this.leftDistance);
      localStorage.setItem('topDistance',this.topDistance);
      // 转换缩放后的道路的数据
      let changedMid = this.changedRoad(
        midScaledLine,
        this.leftDistance,
        this.topDistance
      );
      let changedBar = this.changedRoad1(
        barScaledLine,
        this.leftDistance,
        this.topDistance
      );
      let returnObj = [changedMid, pileNumList, changedBar];
      return [returnObj, this.scaleCode];
    },
    arrToArr(arr) {
      //转换区块
      let setArr = [];
      for (let i = 0; i < arr.length; i++) {
        setArr.push([arr[i].x, -arr[i].y]);
      }
      return setArr;
    },
    arrToArr1(arr) {
      //转换障碍
      let setArr = [];
      for (let i = 0; i < arr.length; i++) {
        let setArr1 = [];
        for (let j = 0; j < arr[i].points.length; j++) {
          setArr1.push({ x: arr[i].points[j].x, y: -arr[i].points[j].y });
        }
        setArr.push(setArr1);
      }
      return setArr;
    },
    arrToDArr(arr, type) {
      let setArr = [];
      for (let i = 0; i < arr.length; i++) {
        setArr.push(arr[i][type]);
      }
      return setArr;
    },
    getMaxAMin(arr, type) {
      if (type == "max") {
        return Math.max.apply(Math, arr);
      } else if (type == "min") {
        return Math.min.apply(Math, arr);
      }
    },
    roadScale(arr, code) {
      let setArr = [];
      for (let i = 0; i < arr.length; i++) {
        setArr.push([arr[i][0] / code, arr[i][1] / code]);
      }
      return setArr;
    },
    roadScale1(arr, code) {
      let setArr = [];
      for (let i = 0; i < arr.length; i++) {
        let setArr1 = [];
        for (let j = 0; j < arr[i].length; j++) {
          setArr1.push({ x: arr[i][j].x / code, y: arr[i][j].y / code });
        }
        setArr.push(setArr1);
      }
      return setArr;
    },
    changedRoad(arr, x, y) {
      let setArr = [];
      for (let i = 0; i < arr.length; i++) {
        setArr.push([arr[i][0] + x, arr[i][1] + y]);
      }
      return setArr;
    },
    changedRoad1(arr, x, y) {
      let setArr = [];
      for (let i = 0; i < arr.length; i++) {
        let setArr1 = [];
        for (let j = 0; j < arr[i].length; j++) {
          setArr1.push({ x: arr[i][j].x * 1 + x, y: arr[i][j].y * 1 + y });
        }
        setArr.push(setArr1);
      }
      return setArr;
    },
    changeSetGray: function () {
      this.setGray = 0;
    },
    saveFun: function () {
      if((this.sectionName+'').trim()==''){
        this.$message({
          message:"作业块名称不能为空！",
          type:'warning'
        })
        return
      }
      this.addObj.sectionName=this.sectionName
      this.addObj.vertexList=this.dataList;
      this.addObj.sourceType=this.sourceType;
      if (this.inType == "edit") {
        this.addObj.id=this.sectionId;
        let params = this.addObj;
        editRoadSection(params).then((res) => {
          if(res.data.code==200){
            this.$message({
              message: "修改成功!",
              type: "success"
          });
          this.$router.push({ name: "UnRoadInfo",query:{id:this.roadId} });
          }
        });
      } else {
        this.addObj.roadId=this.cengid;
        let params=this.addObj;
        addRoadSection(params).then((res) => {
          if(res.data.code==200){
            this.$message({
              message: "添加成功!",
              type: "success"
            });
            this.$router.push({ name: "UnRoadInfo",query:{id:this.roadId}});
          }
        });
      }
    },
  },
  components: {},
  destroyed(){
      // this.websock.close()
  },
  watch:{
  }
};
</script>
<style lang="scss">
.canvas-container1{
  .canvas-container{
    position: fixed !important;
    top: 113px !important;
    left: 370px !important;
  }
}
#dhCanvasun2 {
  position: absolute !important;
  top: 20px !important;
  left: 20px !important;
}
#myCanvasun1 {
  position: absolute !important;
  top: 20px !important;
  left: 20px !important;
}
#midCanvas1 {
  position: absolute !important;
  top: 20px !important;
  left: 20px !important;
}

// #upCanvas2 {
//   position: absolute !important;
//   top: 20px !important;
//   left: 20px !important;
// }
.goBack {
  position: fixed;
  right: 16px;
  top: 68px;
  z-index: 1000;
  height: 35px !important;
  padding-left: 16px !important;
  padding-right: 16px !important;
}
.pointerList {
  .el-input {
    height: 35px;
    width: 78px;
    input {
      height: 35px !important;
      width: 78px !important;
      border-radius: 0;
      padding: 0 10px !important;
    }
  }
}
.sectionSetItem {
  .inputCon {
    height: 25px;
    width: 218px;
    margin-right: 16px;
    float: right;
    line-height: 35px;
    font-size: 14px;
    color: #282828;
    .el-input {
      height: 35px;
      width: 218px;
      input {
        height: 35px !important;
        width: 218px !important;
        border-radius: 0;
      }
    }
    .mileage {
      height: 35px;
      width: 75px;

      input {
        height: 35px !important;
        width: 75px !important;
      }
    }
    .mileage_1 {
      margin: 0 9px;
    }
    .mileage_2 {
      margin-left: 10px;
    }
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.roller{
  .el-input--suffix{
    width: 130px !important;
  }
  .el-input input{
    border-radius: 5px !important;
    width: 140px !important;
  }
}
</style>
<style lang="scss" scoped="">
#img{
  display: none;
}
.pointerName {
  display: inline-block;
  color: #ffffff;
  font-size: 14px;
  padding: 7px;
  background: #e96b5a;
  line-height: 11px;
}
.setSome {
  width: 340px;
  min-height: 853px;
  background-color: #ffffff;
  margin-left: 15px;
  padding-top: 0px;
  padding-bottom: 80px;
  position: relative;
  float: left;
  .title_1 {
    height: 17px;
    width: 100%;
    position: relative;
    margin-bottom: 27px;
    margin-top: 20px;
    .inputCon1 {
      height: 25px;
      width: 148px;
      margin-right: 16px;
      line-height: 25px;
      font-size: 14px;
      color: #282828;
      position: absolute;
      top: 0;
      left: 150px;
    }
    .changePointer {
      width: 90px;
      height: 30px;
      background: rgba(254, 235, 232, 1);
      border: 1px solid rgba(233, 107, 90, 1);
      line-height: 28px;
      text-align: center;
      position: absolute;
      right: 16px;
      top: -6px;
      font-size: 12px;
      color: #e96b5a;
    }
    .iconShow {
      width: 4px;
      height: 16px;
      background: rgba(233, 107, 90, 1);
      position: absolute;
      top: 12px;
      left: 17px;
    }
    .titleText {
      height: 17px;
      line-height: 17px;
      font-size: 16px;
      font-weight: bold;
      color: #222222;
      position: absolute;
      top: 12px;
      left: 30px;
    }
  }
  .sectionSetItem {
    width: 100%;
    height: 35px;
    margin-top: 11px;
    // background-color: aqua;
    .itemText {
      height: 35px;
      line-height: 35px;
      width: auto;
      padding-left: 18px;
      color: #222222;
      font-size: 14px;
      float: left;
    }
  }
  .pointerList {
    width: 309px;
    height: auto;
    margin: 0 auto;
    margin-top: 36px;

    .tableBut {
      margin-top: 10px;
    }
    .barCon {
      margin-top: 10px;
      .barContain {
        display: flex;
        flex-direction: row;
        flex: auto;
        color: #ffffff;
        border: 1px solid #E96B5A;
        margin-bottom: 10px;
        .barname {
          width: 100px;
          background: rgba(233, 107, 90, 1);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .barrecord {
          display: flex;
          flex-wrap: wrap;
          justify-content:center;
          background-color: #fde3e1;
          color: #E96B5A;
          font-size: 12px;
          > div {
            margin-left: 5px;
          }
        }
        .barclose{
            display: flex;
            align-items: center;
            width: 50px;
            background: rgba(233, 107, 90, 1);
            font-size: 28px;
            justify-content: center;
            cursor: pointer;
        }
      }
    }
  }
  .sectionBtn {
    height: 45px;
    width: 310px;
    position: absolute;
    background: rgba(233, 107, 90, 1);
    color: #ffffff;
    line-height: 45px;
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    cursor: pointer;
  }
  .setGray {
    background: gray !important;
    pointer-events: none;
  }
  .saveDiv {
    right: 15px;
    bottom: 20px;
  }
}

.canvasCon2 {
  width: 1533px;
  height: 853px;
  background-color: #ffffff;
  margin-left: 15px;
  float: left;
  position: relative;
  position: fixed;
  top: 113px;
  left: 355px;
}
</style>